import { useGetIntegrationSettingFieldsQuery } from '@/middlewares/defaultApi';
import type { IntegrationInstallationId, SettingField } from '@/types';

export const useIntegrationSettingFields = (
    orgId: string,
    appId: string,
    installationId: IntegrationInstallationId | undefined,
): { settingFields: SettingField[] | undefined; isLoadingSettingFields: boolean; isSettingFieldsError: boolean } => {
    const { data, isFetching, isError } = useGetIntegrationSettingFieldsQuery(
        { orgId, appId },
        { refetchOnMountOrArgChange: false }, // The integrations page already fetched these on mount
    );

    const settingFields = installationId ? data?.data?.[installationId] : undefined;
    return {
        settingFields,
        // A refetch keeps the loaded fields up, so it doesn't replace a form being edited
        isLoadingSettingFields: isFetching && !settingFields,
        isSettingFieldsError: isError,
    };
};
